module.exports = __webpack_public_path__ + "static/media/LoadingSpinner_DesertSand.f9cf29fa.gif";